(function () {
  const BTN_SELECTOR = '.product__details .product-form__actions button.js-add-to-cart';
  const ABRA_SOURCE_SELECTOR = '.product__details .product-form__actions .abra_atc_source';

  function getButton() {
    return document.querySelector(BTN_SELECTOR);
  }
  function getAbraSource() {
    return document.querySelector(ABRA_SOURCE_SELECTOR);
  }
  function isSoldOutOrDisabled(btn) {
    return (
      !btn ||
      btn.hasAttribute('disabled') ||
      btn.getAttribute('aria-disabled') === 'true'
    );
  }

  function getAbraPriceText() {
    const el = getAbraSource();
    if (!el) return null;
    const txt = (el.textContent || '').trim();
    return txt.length ? txt : null;
  }

  // ====== sync ======
  function syncAbraPriceIntoButton() {
    const btn = getButton();
    if (!btn) return;

    if (isSoldOutOrDisabled(btn)) return;

    const abraPriceText = getAbraPriceText();
    if (!abraPriceText) return;

    btn.innerHTML =
      'Add to cart <span class="price-separator">•</span> ' +
      `<span class="abra_price">${abraPriceText}</span>`;
  }

  function setupAbraSourceObserver() {
    const sourceEl = getAbraSource();
    if (!sourceEl) return;

    syncAbraPriceIntoButton();
    const obs = new MutationObserver(() => {
      syncAbraPriceIntoButton();
    });

    obs.observe(sourceEl, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      setupAbraSourceObserver();
      syncAbraPriceIntoButton();
    }, 200);
  });

  document.addEventListener('variant:change', () => {
    setTimeout(syncAbraPriceIntoButton, 0);
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[name="id"], variant-selects select, variant-radios input')) {
      setTimeout(syncAbraPriceIntoButton, 0);
    }
  });
  window.AbraSyncAtcPrice = syncAbraPriceIntoButton;
})();
